import { render } from "./SvgOtherTrailer.vue?vue&type=template&id=636794a8&ts=true"
import script from "./SvgOtherTrailer.vue?vue&type=script&lang=ts"
export * from "./SvgOtherTrailer.vue?vue&type=script&lang=ts"

import "./SvgOtherTrailer.vue?vue&type=style&index=0&id=636794a8&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__